import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { useI18n } from "@/lib/i18n";

export default function FAQ() {
  const { t } = useI18n();
  const items = t("faq.items");

  return (
    <section id="faq" className="section bg-brand-sand" data-testid="section-faq">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("faq.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("faq.title")}</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="rounded-3xl bg-brand-charcoal text-white p-8 relative overflow-hidden h-full">
              <div className="absolute -bottom-10 -end-10 h-40 w-40 rounded-full bg-brand-gold/15 blur-2xl" />
              <div className="text-xs uppercase tracking-[0.22em] text-brand-gold font-semibold">
                {t("faq.eyebrow")}
              </div>
              <div className="mt-4 text-2xl font-extrabold leading-snug">
                {t("faq.title")}
              </div>
              <div className="mt-6 text-sm text-white/70">
                Can&apos;t find your answer? Use the contact form below and we&apos;ll respond within 2 business days.
              </div>
            </div>
          </div>
          <div className="lg:col-span-2">
            <Accordion type="single" collapsible className="rounded-2xl bg-white border border-brand-line divide-y divide-brand-line overflow-hidden" data-testid="faq-accordion">
              {items.map((it, i) => (
                <AccordionItem value={`item-${i}`} key={i} className="border-none">
                  <AccordionTrigger className="px-6 py-5 text-start text-base font-semibold text-brand-charcoal hover:no-underline" data-testid={`faq-trigger-${i}`}>
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-5 text-sm leading-relaxed text-brand-charcoal/70" data-testid={`faq-content-${i}`}>
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
